
<div id="accordionSubjThemes" class="max-width" *ngIf="syllabusinfo">
  <div *ngFor="let topic of syllabusinfo.topics; index as myCount;" class="card" >

    <div class="card-header" id="headingTheme{{topic.id}}">
      <h5 class="mb-0">

        <span *ngIf="topic.questionTemplateCount>0">

            <!--input *ngIf="topic.isSelected" type="checkbox" name="topic" value="{{topic.id}}" checked (change)="updateQuizAreaItem(topic.id)"/-->
            <!--input *ngIf="!topic.isSelected" type="checkbox" name="topic" value="{{topic.id}}" (change)="updateQuizAreaItem(topic.id)"/-->
            <input type="checkbox" name="topic" value="{{topic.id}}" (change)="updateQuizAreaItem(topic.id)"/>
        </span>
        <i *ngIf="topic.questionTemplateCount==0" class="fa fa-square text-secondary"></i>

        <a class="btn btn-link" data-bs-toggle="collapse" href="#collapseTheme{{topic.id}}" aria-expanded="true" aria-controls="collapseOne">
        <span [appMath]="topic.name"></span>
        </a>


      </h5>
    </div>

    <div id="collapseTheme{{topic.id}}" class="collapse {{myCount==0?'show':''}}" aria-labelledby="headingTheme{{topic.id}}" data-parent="#accordionSubjThemes">
      <div class="card-body">
       <app-subtopic-detail [topic]="topic" (subTopicValue)="updateSubTopics($event)"></app-subtopic-detail>
      </div>
    </div>

</div>

<div *ngIf="subTopicIdList.length>0" class="text-center">
  <h1>Selected SubTopics</h1>
  <table  class="table">
    <tr *ngFor="let item of subTopicNameList; index as  counter ">
      <td>{{item}} </td> <td><button class="btn btn-link me-2" (click)="removeItem(counter)"> remove</button></td>
    </tr>
  </table>

</div>

<div class="text-center mt-4" *ngIf="subTopicIdList.length>0">
  <button  class="btn btn-primary m-4" (click)="openEmailForm()"> Generate Free Worksheet
    <i *ngIf="!loading " class='fa fa-file-pdf-o'></i>
    <span *ngIf="loading" class="spinner-border spinner-border-lg me-1 text-info"></span>
  </button>
</div>
<div class="text-center" *ngIf="subTopicIdList.length==0">
  <button class="btn btn-primary m-4"  (click)="alertNoSelectionMade()"> Generate Free Worksheet

  </button>
</div>

<app-email-form
(submitEmailEvent)="validEmailSubmission($event)"
(closeModalRequest)="closeModal()"></app-email-form>
</div>
<div class="text-center" *ngIf="!syllabusinfo">
  <app-spinner></app-spinner>
</div>
